import React, {Component, useState, useEffect, useRef } from 'react';
import './Contact.css';

import { Heading, PageTitle } from '../../components'; 
import { contactContent } from '../../constants'; 

import axios from "axios";
import { FaEnvelope, FaMapMarkedAlt, FaClock, FaPhoneAlt } from 'react-icons/fa';

const API_PATH = 'https://www.example.com/api/phpmailer/submit.php';
     
class Contact extends Component{ 
//const Contact = () => {

  constructor(props) { 
    super(props); 

    // Initialize component state
    this.state = {
      name: '',
      email: '',
      subject: '',
      number: '',
      message: '',
      mailSent: false,
      error: null 
    }
  }

  showRefundPolicy = (e) => {

    e.preventDefault();
    
    const refundPolicySec = document.getElementById('refundPolicy');
    refundPolicySec.innerHTML = "<div class=\"policy\" id=\"policy\">" +
             "<iframe src=\"/credit_card_refund.html\" className=\"policyFrame\" title=\"隱私權條款\" />" +
             "<center>" +
             "<button name=\"closePolicyWindow\" id=\"closePolicyWindow\" class=\"btn\" onClick=\"document.getElementById('refundPolicy').innerHTM='';\" >我同意</button>" +
             "</center>" +
           "</div>";

    alert('ok');
  }
  
  
  // Handle form submission
  handleSubmitForm = (e) => {

    e.preventDefault();

    // Update submit button text
    const submitBtn = document.querySelector('#submit');
    submitBtn.innerText = 'please wait';

    if (!this.isFormValid()) {
      this.setState({ formError: true });
      submitBtn.innerText = '送出';
      return;
    }

    // Reset mailSent state
    this.setState({
      mailSent: false
    })

    // Create form data
    let formData = new FormData();
    formData.append("name", this.state.name);
    formData.append("email", this.state.email);
    formData.append("subject", this.state.subject);
    formData.append("number", this.state.number);
    formData.append("message", this.state.message);

    // Send form data via axios post request
    axios({
      method: 'post',
      url: `${API_PATH}`,
      headers: { "Content-Type": "multipart/form-data" },
      data: formData
    })

    .then(result => {

      // Update mailSent state and reset form fields
      this.setState({
        mailSent: result.data.sent,
        name: '', email: '', subject: '', number: '', message: ''
      })

      // Reset submit button text
      submitBtn.innerText = 'submit';

    })

    .catch(error => this.setState({ error: error.message }));

    // Reset form error state
    this.setState({ formError: false });

  } 

  // Form validation
  isFormValid = () => {
    const { name, email, subject, number, message } = this.state;
    return name !== '' && email !== '' && subject !== '' && number !== '' && message !== '';
  };

 

  render(){
    return (
      <> 

        {/* Page Title */}
        <PageTitle title={'與我們聯絡'} page={'contact'} />
      
        {/* Contact Section */}
        <section className='contact' id='contact'>

          <div className='box-container'>

            {/* Contact Form */}
            <div className='contact-container'>

              <Heading title={'客服與處理'} /> 
              <p className="content">如果您在使用本服務遇到現場停車、帳務或是綁定支付等相關問題，歡迎與我們聯繫。我們將盡快為您服務。</p>
              <p className="content">停車聰明繳費使用全支付、LinePay、信用卡進行綁定。綁定後將會自動在您離場後一天內進行自動扣款。
                                      相關扣款紀錄可在會員中心進行查詢。貼心提醒：聰明停車服務需要您完成大潤發聯名卡與支付方式綁定完成後才可以啟動服務</p>
                                      <p className="content">有關於綁定全支付、LinePay、信用卡相關退費與扣款相關問題，請點選「 <a href='/RefundPolicy'><span>退費政策</span></a>」近一步查詢。</p>
              <p className="content">Fukuro 客服團隊貼心為您服務 </p>
              
              <Heading title={'填寫表格'} /> 
              
              <form method="post" className='contact-form' id="contactUs-Form">

                {/* Form Inputs */} 
                <div className='input-box'>
                  <input type="text" name="name" className='box' id="name" value={this.state.name} onChange={e => this.setState({ name: e.target.value })} placeholder="聯絡人" required /> {/* Name Input Field */}
                  <input type="email" name="email" className='box' id="email" value={this.state.email} onChange={e => this.setState({ email: e.target.value })}  placeholder="ˇ電子信箱" required /> {/* Email Input Field */}
                </div>
                <div className='input-box'>
                <input type="text" name="subject" className='box' id="subject" value={this.state.subject} onChange={e => this.setState({ subject: e.target.value })} placeholder="聯絡事項" /> {/* Subject Input Field */}
                  <input type="number" name="number" className='box' id="number" value={this.state.number} onChange={e => this.setState({ number: e.target.value })}  placeholder="電話號碼" required /> {/* Number Input Field */}
                </div>
                <textarea cols="30" rows="10" name="comment" id="comment" className='box' value={this.state.message} onChange={e => this.setState({ message: e.target.value })} placeholder="內容"></textarea> {/* Textarea for message */}
                
                <div className='msg-alert'>
                  {/* Submit Button */}
                  <button type="submit" onClick={e => this.handleSubmitForm(e)} name="submit" id="submit" className='btn'>送出</button>
                  
                  {/* Display form error alert */}
                  {this.state.formError && (
                    <span className='alert'>請填寫必要欄位</span> /* Alert for form errors */
                  )}

                  {/* Mail Sent Alert */}
                  {this.state.mailSent &&
                    <span className="alert">訊息已經成功送出</span> /* Alert for successful message sent */
                  }
                </div>
              
              </form> 

              
            </div>
            {/* Contact Information */}

            <div className='contact-info'>

              <Heading title={'大潤發停車場客服聯絡'} /> 
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>內湖店</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0935-991-909</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>碧潭</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>景平</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>土城</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>忠孝</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>中壢</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>頭份</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>湳雅</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>八德、</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>忠明</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>嘉義</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>員林</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>台南</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>
                <div className='info-item' key="rt-neihu"> 
                        <div className='icon'> <FaPhoneAlt /></div> {/* Contact Info icon */}
                        <div className="content">
                          <h3>鳳山</h3> {/* Contact Info title */}
                          {/* Map over the details array to display each item */}
                          <p key="rt-neihu">0800-208-333</p>
                        </div>
                </div>

            </div>



            {/* Contact Information */}
            {/* <div className='contact-info'>

              <Heading title={'公司聯絡資訊'} /> 
             
              { 
                // Map over the contactContent array to render each contact information item
                contactContent.map((contact) => { 
                  let details = contact.content;
                  return (
                    <div className='info-item' key={contact.id}> 
                      <div className='icon'>{contact.icon}</div> 
                      <div className="content">
                        <h3>{contact.title}</h3> 
                        {details.map((value, index) => {
                          return <p key={index}>{value}</p>
                        })}
                      </div>
                    </div>
                  )
                })
              }
            </div> */}

          </div>

          {/* Google Maps */}
          <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3616.8080531836054!2d121.52747531206802!3d24.972644440664947!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346803469d8d53c1%3A0x87fb3280f065aa08!2z6aCG5bq36LOH55Si566h55CG6aGn5ZWP5pyJ6ZmQ5YWs5Y-4!5e0!3m2!1szh-TW!2stw!4v1718611586508!5m2!1szh-TW!2stw" 
            allowFullScreen loading="lazy"></iframe>
          <div id="refundPolicy" className='refundPolicy'></div>

        </section>
      </>
    )
  }
}
  
 export default Contact;